import React, { type ReactNode } from "react";
import { useSelector } from "react-redux";
import type { RootState } from "../../store/store";
import { UserRole } from "../Profile/enums/profileEnums";
import FeatureUnavailablePage from "./FeatureUnavailablePage";

interface EducationRouteGuardProps {
  /** When set, only these roles may view the route. */
  allowedRoles?: UserRole[];
  /** Custom predicate — evaluated after role is resolved. */
  canAccess?: (role: UserRole | undefined) => boolean;
  children: ReactNode;
}

/**
 * Role guard for `/portal/education/*` child routes (P0.6).
 */
const EducationRouteGuard: React.FC<EducationRouteGuardProps> = ({
  allowedRoles,
  canAccess,
  children
}) => {
  const userDetails = useSelector((state: RootState) => state.user.userDetails);
  const role = (userDetails?.role as UserRole | undefined) ?? undefined;

  if (allowedRoles != null && allowedRoles.length > 0) {
    if (role == null || !allowedRoles.includes(role)) {
      return <FeatureUnavailablePage />;
    }
  }

  if (canAccess != null && !canAccess(role)) {
    return <FeatureUnavailablePage />;
  }

  return <>{children}</>;
};

export default EducationRouteGuard;
